export default "__VITE_ASSET__DX877I$X__"